<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        :loading="loading"
        @save="$refs.Form.save()"
        extra-large
        ref="RkmModal"
        title="Cadastro de logradouro"
    >
        <Form
            :classificacao_id="classificacao_id"
            @save="handleExit"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from '@/components/cadastro/logradouro/Form'

// Vuex.
import {mapGetters} from 'vuex'

export default {
    components: {Form},
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('cadastro-logradouro-form')
        },
    },
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
        handleExit(logradouro) {
            this.$emit('save', logradouro)
            this.$refs.RkmModal.hide()
        },
    },
    props: {
        classificacao_id: {type: Number},
    },
}
</script>